<template>
    <div class="modal fade" id="updatesModal" tabindex="-1" aria-labelledby="updatesModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
            <div class="modal-content modal_wrapper">
                <div class="modal-header border-0">
                    <h2 class="title" id="updatesModalLabel">{{ $t('general.updates') }}</h2>
                </div>
                <div class="modal-body changelog_body">
                    <div v-if="updates && updates.length > 0">
                        <div v-for="update in updates" :key="update.id" class="changelog_entry">
                            <span class="version_badge">{{ $t('general.version') }} {{ update.version_number }}</span>
                            <div v-if="update.new_features && update.new_features.length > 0" class="changelog_section">
                                <h4 class="section_title new_title">{{ $t('general.newFeatures') }}</h4>
                                <ul class="changelog_list">
                                    <li v-for="new_feature in update.new_features" :key="new_feature.id">
                                        {{ new_feature.name }}
                                    </li>
                                </ul>
                            </div>
                            <div v-if="update.changed_features && update.changed_features.length > 0"
                                class="changelog_section">
                                <h4 class="section_title changed_title">{{ $t('general.changedFeatures') }}</h4>
                                <ul class="changelog_list">
                                    <li v-for="change in update.changed_features" :key="change.id">
                                        {{ change.name }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer border-0">
                    <button type="button" class="btn btn_main px-5" @click="submitSeen">OK</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Modal } from "bootstrap"; // Import Bootstrap's modal class

export default {
    data() {
        return {
            updates: [],
            user: {},
            modalInstance: null,
        }
    },
    created() {
        this.loadData()
    },
    methods: {
        loadData() {
            this.$store.getters.api.get('/updates').then(res => {
                this.updates = res.data.items;
                this.user = this.$store.state.user;

                if (this.updates.length > 0 && !this.user.seen_updates) {
                    this.showModal();
                }
            })
        },
        showModal() {
            const modalElement = document.getElementById("updatesModal");

            // Remove existing backdrops to prevent duplication
            document.querySelectorAll('.modal-backdrop').forEach(backdrop => backdrop.remove());

            if (!this.modalInstance && modalElement) {
                this.modalInstance = new Modal(modalElement, { backdrop: "static", keyboard: false });
            }

            // Check if the modal is not already shown
            if (modalElement && !modalElement.classList.contains("show")) {
                this.modalInstance.show();
            }
        },
        submitSeen() {
            this.$store.getters.api.post(`/update/user/${this.user.id}/seen`).then(res => {
                this.$emit('seen', true);
                this.$store.getters.user.seen_updates = true
                if (this.modalInstance) {
                    this.modalInstance.hide();
                    this.modalInstance = null;
                }
            })
        }
    }
}
</script>
<style scoped lang="scss">
@import "@/scss/abstracts/variables";
@import "@/scss/base/typography.scss";

.modal_wrapper {
    padding: 10px 16px;
    border-radius: $radius-xl;
}

.changelog_body {
    padding: 8px 16px 16px;
}

.changelog_entry {
    &+.changelog_entry {
        margin-top: 22px;
        padding-top: 20px;
        border-top: 1px solid $border;
    }
}

.version_badge {
    display: inline-block;
    background: $accent;
    color: $white;
    font-family: $font-heading;
    font-weight: 600;
    font-size: 15px;
    padding: 4px 16px;
    border-radius: $radius-pill;
    margin-bottom: 14px;
}

.changelog_section {
    margin-top: 14px;
}

.section_title {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 6px;
    font-size: 14px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    color: $text;

    &::before {
        content: '';
        width: 10px;
        height: 10px;
        border-radius: 50%;
        flex: 0 0 auto;
    }

    &.new_title::before {
        background: #28a745;
    }

    &.changed_title::before {
        background: $accent;
    }
}

.changelog_list {
    list-style: none;
    padding-left: 18px;
    margin: 0;

    li {
        position: relative;
        padding: 3px 0;
        color: $text;
        line-height: 1.5;

        &::before {
            content: '•';
            position: absolute;
            left: -14px;
            color: $text-muted;
        }
    }
}
</style>